import cornerstone from 'cornerstone-core';

export const resizeCornerstoneViewports = () => {
  cornerstone.getEnabledElements().forEach(({ element }) => {
    if (element.isConnected) {
      cornerstone.resize(element, true);
    }
  });
};
